import React, { useEffect, useState, PureComponent } from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ZAxis, LineChart } from 'recharts';
import { scaleLog } from 'd3-scale';
import { useTranslation } from 'react-i18next';

import { PartialDischargeGraphXYDataModel } from './../PartialDischarge';

type PartialDischargeGraphRightChartProps = {
    cumulativeFrequencyGraphList: PartialDischargeGraphXYDataModel[] | undefined;
};

type XYItem = {
    x: number;
    y: number;
}

const scale = scaleLog().base(10);
const scaleX = scaleLog().base(Math.E);

const PartialDischargeGraphRightChart: React.FC<PartialDischargeGraphRightChartProps> = (props) => {
    const { t } = useTranslation();
    console.debug(["PartialDischargeGraphRightChart-start"]);

    /**
     * グラフ表示の値を入手
     * @returns 
     */
    const GetXYItems = (): XYItem[] => {
        let dataList: XYItem[] = [];
        let tempList = props.cumulativeFrequencyGraphList;

        if (tempList !== undefined) {
            tempList.map((row, index) => {
                let xValue = row.XValue !== undefined ? row.XValue : 0;
                let yValue = row.YValue !== undefined ? row.YValue : 0;
                if (xValue >= 1) {
                    dataList.push({
                        x: xValue,
                        y: yValue
                    })
                }

            })
            console.debug(["PartialDischargeGraphRightChart --dataList--",
                props.cumulativeFrequencyGraphList, dataList, tempList]);
        }

        return dataList;
    }

    return (
        <>
            {props.cumulativeFrequencyGraphList !== undefined ?
                <ResponsiveContainer width="100%" height="100%">
                    <ScatterChart
                        margin={{
                            top: 20,
                            right: 20,
                            bottom: 20,
                            left: 20,
                        }}
                    >
                        <CartesianGrid />
                        <XAxis type="number" dataKey="x" name={t('PartialDischargeGraphRightChart.PD強度', 'PD強度')}
                            tickCount={2}
                            domain={[1, 10]}
                            ticks={[1, 10]}
                            tickFormatter={(props) => props.toFixed(2)}
                            tick={{ dy: 10 }}
                            scale={scaleX}
                        />
                        <YAxis type="number" dataKey="y" name={t('PartialDischargeGraphRightChart.発生頻度', '発生頻度')}
                            tickCount={6} domain={[1, 100000]}
                            ticks={[1, 10, 100, 1000, 10000, 100000]}
                            scale={scale}
                        />
                        <ZAxis range={[20, 20]} />
                        <Tooltip cursor={{ strokeDasharray: '3 3' }}
                            isAnimationActive={false}
                        />
                        <Scatter name="A school" data={GetXYItems()} fill="#8884d8" />
                    </ScatterChart>
                </ResponsiveContainer>
                : null
            }
        </>
    )
}
export default PartialDischargeGraphRightChart;